<template>
  <div class="p-front__content">
    <!-- {{ regSuccess }} -->
    <div class="p-signup" v-if="regSuccess == false" style="margin: 80px 0px;">
      <el-form
        class="p-signup__form"
        style="width: 80%;"
        method="POST"
        @submit="submitReg"
      >
        <!-- <img class="p-signin-a__form-heading" src="https://arnergy.com/logo.png" alt height="50px;"> -->
        <h4 class="p-signup__form-heading">Create new customer</h4>
        <div class="p-signup__form-content">
          <!-- {{regDataParams}} -->
          <b-alert variant="danger" dismissible :show="displayError">{{
            errorMessage
          }}</b-alert>
          <el-form-item class="form-item" label="Contact">
            <el-autocomplete
              style="width: 100%"
              id="customer-contact"
              class="inline-input"
              v-model="formContact"
              :fetch-suggestions="contactSearch"
              placeholder="Search contact"
              prefix-icon="el-icon-search"
              @select="contactSelected"
            ></el-autocomplete>
          </el-form-item>

          <div>
            <button
              type="submit"
              class="btn btn-info btn-block btn-lg p-signup__form-submit"
              @click="submitReg"
            >
              Convert contact
            </button>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// import { VueNotifications } from '../../main';
import axios from "axios";
// import VueNotifications from 'vue-notifications';
import {
  Select,
  Button,
  Autocomplete,
  Form,
  FormItem,
  Radio,
  RadioGroup,
  RadioButton
} from "element-ui";
var getSearchParams = k => {
  var p = {};
  var LocationAddr = window.location.toString().split("?")[1];
  LocationAddr.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(s, k, v) {
    p[k] = v;
  });
  return k ? p[k] : p;
};

export default {
  name: "new-user",
  components: {
    "el-form": Form,
    "el-form-item": FormItem,
    "el-radio": Radio,
    "el-radio-group": RadioGroup,
    "el-radio-button": RadioButton,
    "el-autocomplete": Autocomplete
  },
  data() {
    return {
      ZcontactList: [],
      formContact: "",
      roleData: [],
      regSuccess: false,
      regDataParams: {
        noMail: true,
        firstName: null,
        roleType: "customer",
        lastName: null,
        dateOfBirth: new Date(),
        gender: 0,
        phoneNumber: null,
        realm: "",
        username: "",
        email: null,
        street_route: null,
        password: "<%DUMMY%>",
        cpassword: "<%DUMMY%>",
        stateId: null,
        countryId: 1,
        lgaId: null
      },
      errors: {},
      displayError: false,
      errorMessage: "",
      selectedState: null,
      selectedLga: null,
      stateOptions: [
        {
          value: null,
          disabled: true,
          text: "Please select a state"
        }
      ],
      lgaOptions: [
        {
          value: null,
          disabled: true,
          text: "Please select LGA"
        }
      ]
      // genderOptions: [
      //   {
      //     text: "Male",
      //     value: 1
      //   },
      //   {
      //     text: "Female",
      //     value: 0
      //   }
      // ]
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  computed: {
    // lgaOptions() {
    //   const state = this.selectedState;
    //   return state;
    // },
  },
  methods: {
    contactSelected(contact) {
      this.regDataParams = {
        ...this.regDataParams,
        firstName: contact["First_Name"],
        lastName: contact["Last_Name"],
        phoneNumber: contact["Phone"],
        username: contact["Email"],
        email: contact["Email"]
      };
    },
    createFilter(queryString, contact) {
      return (
        `${contact.First_Name} ${contact.Last_Name}`
          .toLowerCase()
          .indexOf(queryString.toLowerCase()) > -1
      );
    },
    contactSearch(queryString, cb) {
      let contacts = this.contactList;
      var results = queryString
        ? contacts.filter(contact => this.createFilter(queryString, contact))
        : contacts;
      cb(results);
    },
    loadAll(page = 1) {
      console.log("++++++++++++++++++++++++++");
      console.log(page);
      const ZOHOTHTTP = this.$httpUtils.ZOHOTHTTP;
      let container = this;
      let collection = "Contacts?fields=Email,First_Name,Last_Name,Phone";
      if (page > 1) {
        collection =
          "Contacts?fields=Email,First_Name,Last_Name,Phone&page=" + page;
      }
      ZOHOTHTTP.get(`fetchAll`, {
        params: {
          collection
        }
      })
        .then(response => response.data["result"])
        .then(resultData => {
          let tempList = resultData["data"];
          // console.log(tempList);
          container.ZcontactList = [
            ...container.ZcontactList,
            ...tempList.map(x => ({
              ...x,
              value: x.First_Name
                ? `${x.First_Name} ${x.Last_Name}`
                : x.Last_Name
            }))
          ];
          container.contactList = container.ZcontactList;
          console.log(container.ZcontactList);
          if (resultData["info"]["more_records"] == true) {
            this.loadAll(resultData["info"]["page"] + 1);
          }
        })
        .catch(e => {
          console.log("========Err=========");
          console.log(e);
          // this.refreshZohoToken();
        });
    },
    isEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.toLowerCase());
    },
    submitReg(e) {
      e.preventDefault();
      var container = this;
      if (this.formContact.length < 0) {
        this.errorMessage = "Fill All FIelds!!!";
        this.displayError = true;
        setTimeout(() => {
          this.displayError = false;
        }, 3000);
        var errorMsg = Object.values(this.errors).join("<br>");
        // console.log()
        this.showErrorMsg({
          message: errorMsg
        });
      } else {
        const tempReg = this.regDataParams;
        console.log(tempReg);
        const HTTP = this.$httpUtils.instance;
        const url = "/users";
        HTTP.post(url, tempReg)
          .then(response => {
            container.regSuccess = true;
            this.showSuccessMsg({
              message: "User Created!"
            });
            this.$router.push({ path: "/customers" });
          })
          .catch(error => {
            // console.log(error.response.data.error);
            if (error.response.data.error.details) {
              var errorMsg = error.response.data.error.details.messages;
              var errTemp = [];
              var keyHooks = Object.keys(errorMsg);
              Object.values(errorMsg).map((x, index) => {
                errTemp[index] = keyHooks[index] + " " + x[0];
              });
              errTemp = Object.values(errTemp).join("<br>");
              this.showErrorMsg({
                message: errTemp
              });
            } else {
              if (tempReg.email == null) {
                this.showErrorMsg({
                  message: "Please select a contact"
                });
              } else {
                this.showErrorMsg({
                  message: error.response.data.error.message
                });
              }
            }
          });
      }
    },
    fetchStates() {
      const HTTP = this.$httpUtils.instance;
      const url = "/states";
      HTTP.get(url)
        .then(response => {
          // console.log(JSON.stringify(response))
          const statesList = response.data;
          let str = JSON.stringify(statesList);
          str = str.replace(/id/g, "value");
          str = str.replace(/name/g, "text");
          let tempState = JSON.parse(str);
          tempState = tempState.map(x => {
            return {
              ...x,
              text: x.text[0].toUpperCase() + x.text.substring(1)
            };
          });
          tempState.unshift({
            value: null,
            disabled: true,
            text: "Please select a state"
          });
          this.stateOptions = tempState;
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    fetchLgas(state) {
      if (state !== null) {
        const context = this;
        const HTTP = this.$httpUtils.instance;
        const url = `/states/${state}/lgas`;
        HTTP.get(url)
          .then(response => {
            const statesList = response.data;
            let str = JSON.stringify(statesList);
            str = str.replace(/id/g, "value");
            str = str.replace(/name/g, "text");
            let tempLga = JSON.parse(str);
            tempLga = tempLga.map(x => {
              return {
                ...x,
                text: x.text[0].toUpperCase() + x.text.substring(1)
              };
            });
            tempLga.unshift({
              value: null,
              disabled: true,
              text: "Please select LGA"
            });
            context.lgaOptions = tempLga;
          })
          .catch(error => {
            console.log("error", error);
          });
      }
    },
    fetchUserRoles() {
      //    fetchPreviledges() {
      const HTTP = this.$httpUtils.instance;
      const container = this;
      const url = "/roles/";
      HTTP.get(url)
        .then(response => {
          container.roleData = response.data;
          //  this.$store.commit("setRole", self.roleData);
          //this.setRole(self.roleData);
        })
        .catch(error => {
          console.log("error", error);
        });
      // },
    }
  },
  mounted() {
    this.loadAll();
    // (getSearchParams('q') !== undefined)? getSearchParams('q') :
    // (getSearchParams('v') !== undefined)? getSearchParams('v')
    // this.fetchStates();
    // this.fetchUserRoles();
    // const user_type_token = (getSearchParams('s') !== undefined)? getSearchParams('s') : 'CUSTOMER';
    // const user_type_token = this.$route.query.s ||  this.$route.query.q ||  this.$route.query.v || 'CUSTOMER';
    // console.log("===================")
    // var LocationAddr =window.location.toString().split('?')[1];
    // console.log(user_type_token)
    // console.log(getSearchParams('s'));
  }
};
</script>

<style scoped>
h4.p-signup__form-heading {
  font-weight: 600;
  color: #6a707e;
  border: none;
}

#state_dd {
  width: 100%;
}

#state_dd #state_dd__BV_toggle_ {
  width: 100% !important;
}

#reg_success {
  position: absolute;
  height: 100vh;
  width: 100%;
  top: 0;
  left: 0;
  padding: 0px;
  z-index: 999;
}

.form-group label {
  color: #424242;
}
.p-signin-a__form-heading {
  margin: 50px 175px;
  border: none;
}
input[type="email"] {
  /* background-image: url("../../assets/img/mail.png"); */
  background-position: 7px 15px;
  background-repeat: no-repeat;
}

.p-signup__form-link:last-child {
  margin-bottom: 20px;
}
input[type="text"] {
  /* background-image: url("../../assets/img/profile2.png"); */
  background-position: 7px 15px;
  background-repeat: no-repeat;
}
input[type="phone-number"] {
  /* background-image: url("../../assets/img/smartphone-call.png"); */
  background-position: 7px 15px;
  background-repeat: no-repeat;
}
input[type="address"] {
  /* background-image: url("../../assets/img/placeholder.png"); */
  background-position: 7px 15px;
  background-repeat: no-repeat;
}
select {
  background-color: #ebeff2 !important;
  text-indent: 0px;
}
input[type="password"] {
  /* background-image: url("../../assets/img/key2.png"); */
  background-position: 7px 15px;
  background-repeat: no-repeat;
}
input[type="checkbox"] {
  height: 0rem;
  margin-right: 20px;
}
.p-signup__form-submit {
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/users/new-customer.vue